import { useComposablePage } from '@bnnvara/composable';
import React from 'react';

import withBrandedComposablePage from '../../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../../layouts/ComposablePageLayout';
import pageData from './MediaOverview.json';
import MediaOverviewQuery from './MediaOverviewQuery.gql';

const MediaOverviewPage = () => {
  const { render } = useComposablePage();
  const content = render(pageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: MediaOverviewQuery,
})(MediaOverviewPage);
